import { __assign, __rest } from "tslib";
import React, { useMemo } from 'react';
import classnames from 'classnames';
import BaseViewer from './Base';
import mergeTheme from '../Themes/mergeTheme';
import baseTheme from '../Themes/Viewer/status.scss';
var StatusViewer = function (_a) {
    var themeFromProps = _a.theme, isShortStatus = _a.isShortStatus, props = __rest(_a, ["theme", "isShortStatus"]);
    var theme = useMemo(function () { return mergeTheme(baseTheme, themeFromProps); }, [
        themeFromProps,
    ]);
    return (React.createElement("div", { className: classnames('da-editor-status', isShortStatus && 'da-editor-status-short') },
        React.createElement(BaseViewer, __assign({ theme: theme }, props, { fixedParagraph: false }))));
};
StatusViewer.displayName = 'StatusViewer';
export var ShortStatusViewer = function (props) { return (React.createElement(StatusViewer, __assign({}, props, { isShortStatus: true }))); };
ShortStatusViewer.displayName = 'ShortStatusViewer';
export var LongStatusViewer = function (props) { return (React.createElement(StatusViewer, __assign({}, props))); };
LongStatusViewer.displayName = 'LongStatusViewer';
export default StatusViewer;
//# sourceMappingURL=Status.js.map